import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiHelper } from 'src/app/core/services/api-helper';

@Injectable({
  providedIn: 'root',
})
export class FrillServiceService {
  constructor(private readonly apiHelper: ApiHelper) {}

  /** The API mints the token for the signed-in person from their own record, so nothing is sent (#1747). */
  public getToken(): Observable<string> {
    const url = `${environment.API_URL}GetFrillToken`;
    return this.apiHelper.postWithAccessToken(url, null);
  }
}
